var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    {
      attrs: {
        showSearch: true,
        filterOption: false,
        allowClear: true,
        loading: _vm.customerOption.fetching,
        disabled: _vm.disabled,
        value: _vm.value
      },
      on: {
        search: _vm.searchCustomer,
        input: _vm.handleChange,
        change: _vm.handleChange
      }
    },
    _vm._l(_vm.customerOption.data, function(item, index) {
      return _c(
        "a-select-option",
        { key: index, attrs: { value: item.id } },
        [
          _c(
            "a-tooltip",
            [
              _c("template", { slot: "title" }, [
                _vm._v(" " + _vm._s("" + item.fullName) + " ")
              ]),
              _vm._v(" " + _vm._s("" + item.fullName) + " ")
            ],
            2
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }